import React, { Component, Fragment } from "react";
import { User, Unlock, Mail, Lock, Eye, EyeOff, AlertTriangle } from "react-feather";
import { withRouter } from "react-router-dom";
import {
  auth,
  createAdminProfileDocument,
  firestore,
} from "../../firebase/firebase.utils";
import { notifySuccess, notifyWarning, notifyError } from "../../utils/notify";

export class LoginTabset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "login",
      startDate: new Date(),
      loginEmail: "",
      loginPassword: "",
      registerEmail: "",
      registerPassword: "",
      registerConfirmPassword: "",
      registerStatus: "",
      registerDisplayName: "",
      showPassword: false,
      capsLock: false,
      signingIn: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleLoginSubmit = async (event) => {
    event.preventDefault();
    const { loginEmail, loginPassword, signingIn } = this.state;
    if (signingIn) return;
    this.setState({ signingIn: true });
    try {
      await auth.signInWithEmailAndPassword(loginEmail, loginPassword);
      this.setState({ loginEmail: "", loginPassword: "" });
      auth.onAuthStateChanged(async (userAuth) => {
        if (userAuth) {
          const adminRef = firestore.doc(`admins/${userAuth.uid}`);
          const snapShot = await adminRef.get();
          if (snapShot.exists) {
            if (
              snapShot.data().activeStatus &&
              snapShot.data().activeStatus === "Inactive"
            ) {
              notifyError("Your account is deactivated");
              this.setState({ signingIn: false });
              return;
            }
            this.props.setCurrentAdmin({ id: snapShot.id, ...snapShot.data() });
            this.props.history.push(`${process.env.PUBLIC_URL}/dashboard`);
          } else {
            this.setState({ signingIn: false });
          }
        } else {
          notifyError("your email is not authenticated");
          this.setState({ signingIn: false });
        }
      });
    } catch (error) {
      notifyError(error.message || String(error));
      this.setState({ signingIn: false });
    }
  };

  handlePasswordKey = (event) => {
    if (event.getModifierState) {
      this.setState({ capsLock: event.getModifierState("CapsLock") });
    }
  };

  handleRegisterSubmit = async (event) => {
    event.preventDefault();
    const {
      registerEmail,
      registerPassword,
      registerConfirmPassword,
      registerStatus,
      registerDisplayName,
    } = this.state;
    if (registerPassword !== registerConfirmPassword) {
      notifyWarning("passwords don't match");
      return;
    }
    try {
      const { user } = await auth.createUserWithEmailAndPassword(
        registerEmail,
        registerPassword
      );
      await createAdminProfileDocument(user, {
        name: registerDisplayName,
        status: registerStatus,
      });
      this.setState({
        registerDisplayName: "",
        registerEmail: "",
        registerPassword: "",
        registerConfirmPassword: "",
      });
      this.props.history.push("/dashboard");
    } catch (error) {
      notifyError(error.message || String(error));
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    var emailAddress = this.state.loginEmail;
    if (!emailAddress) {
      notifyWarning("Please enter your email address");
      return;
    }
    auth
      .sendPasswordResetEmail(emailAddress)
      .then(() => {
        notifySuccess(
          "Password reset email has been sent to your email address. Please check your email."
        );
      })
      .catch((error) => {
        notifyError(error.message);
      });
    this.setState({ emailAddress: "" });
  };

  render() {
    const { activeTab } = this.state;
    const canRegister =
      this.props.currentAdmin &&
      this.props.currentAdmin.status === "Admin";

    return (
      <div>
        {canRegister && (
          <div className="login-tabs">
            <button
              type="button"
              className={`login-tab-btn${activeTab === "login" ? " active" : ""}`}
              onClick={() => this.setState({ activeTab: "login" })}
            >
              <User size={14} />
              Login
            </button>
            <button
              type="button"
              className={`login-tab-btn${activeTab === "register" ? " active" : ""}`}
              onClick={() => this.setState({ activeTab: "register" })}
            >
              <Unlock size={14} />
              Register
            </button>
          </div>
        )}

        {activeTab === "login" && (
          <form onSubmit={this.handleLoginSubmit}>
            <div className="login-field">
              <label htmlFor="loginEmail">Email address</label>
              <div className="login-input-wrap">
                <Mail size={18} className="login-input-icon" aria-hidden="true" />
                <input
                  id="loginEmail"
                  required
                  name="loginEmail"
                  value={this.state.loginEmail}
                  onChange={this.handleChange}
                  type="email"
                  autoComplete="username"
                  className="login-input"
                  placeholder="you@example.com"
                />
              </div>
            </div>
            <div className="login-field">
              <label htmlFor="loginPassword">Password</label>
              <div className="login-input-wrap">
                <Lock size={18} className="login-input-icon" aria-hidden="true" />
                <input
                  id="loginPassword"
                  required
                  name="loginPassword"
                  value={this.state.loginPassword}
                  onChange={this.handleChange}
                  onKeyDown={this.handlePasswordKey}
                  onKeyUp={this.handlePasswordKey}
                  onBlur={() => this.setState({ capsLock: false })}
                  type={this.state.showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  className="login-input"
                  placeholder="••••••••"
                  aria-describedby={this.state.capsLock ? "login-caps" : undefined}
                />
                <button
                  type="button"
                  className="login-eye"
                  aria-label={this.state.showPassword ? "Hide password" : "Show password"}
                  aria-pressed={this.state.showPassword}
                  onClick={() =>
                    this.setState((prev) => ({ showPassword: !prev.showPassword }))
                  }
                >
                  {this.state.showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
              {this.state.capsLock && (
                <p id="login-caps" className="login-caps" role="status">
                  <AlertTriangle size={14} aria-hidden="true" />
                  Caps Lock is on
                </p>
              )}
            </div>
            <div className="login-meta-row">
              <label className="login-remember">
                <input type="checkbox" />
                Remember me
              </label>
              <button
                type="button"
                className="login-forgot"
                onClick={(e) => this.handleSubmit(e)}
              >
                Forgot password?
              </button>
            </div>
            <button
              className={"login-submit-btn" + (this.state.signingIn ? " is-loading" : "")}
              type="submit"
              disabled={this.state.signingIn}
              aria-busy={this.state.signingIn}
            >
              {this.state.signingIn ? (
                <span className="login-submit-loading">
                  Signing in
                  <span className="login-dots" aria-hidden="true">
                    <i />
                    <i />
                    <i />
                  </span>
                </span>
              ) : (
                "Sign in"
              )}
            </button>
          </form>
        )}

        {activeTab === "register" && canRegister && (
          <form onSubmit={this.handleRegisterSubmit}>
            <div className="login-field">
              <label>Full name</label>
              <input
                required
                name="registerDisplayName"
                value={this.state.registerDisplayName}
                onChange={this.handleChange}
                type="text"
                className="login-input"
                placeholder="Your full name"
              />
            </div>
            <div className="login-field">
              <label>Email address</label>
              <input
                required
                name="registerEmail"
                value={this.state.registerEmail}
                onChange={this.handleChange}
                type="email"
                className="login-input"
                placeholder="name@example.com"
              />
            </div>
            <div className="login-field">
              <label>Password</label>
              <input
                required
                name="registerPassword"
                value={this.state.registerPassword}
                onChange={this.handleChange}
                type="password"
                className="login-input"
                placeholder="••••••••"
              />
            </div>
            <div className="login-field">
              <label>Confirm password</label>
              <input
                required
                name="registerConfirmPassword"
                value={this.state.registerConfirmPassword}
                onChange={this.handleChange}
                type="password"
                className="login-input"
                placeholder="••••••••"
              />
            </div>
            <div className="login-field">
              <label>Role</label>
              <select
                className="login-select"
                name="registerStatus"
                value={this.state.registerStatus}
                onChange={this.handleChange}
                required
              >
                <option value="">Select role</option>
                <option value="Admin">Admin</option>
                <option value="Accounts">Accounts</option>
                <option value="Employee">Employee</option>
                <option value="Officer">Officer</option>
              </select>
            </div>
            <div className="login-terms">
              <input type="checkbox" required />
              I agree to the{" "}
              <a href="">Terms &amp; Conditions</a>
            </div>
            <button className="login-submit-btn" type="submit">
              Create account
            </button>
          </form>
        )}
      </div>
    );
  }
}

export default withRouter(LoginTabset);
